import getLiveStandings from '~/util/getLiveStandings';

const getMatchupStandings = async (leagueSlug, homeTeamId, awayTeamId) => {
  const liveStandings = await getLiveStandings(leagueSlug);

  const homeTeamStandings = liveStandings.find(({ team }) => team.id === homeTeamId);
  const awayTeamStandings = liveStandings.find(({ team }) => team.id === awayTeamId);

  if (!homeTeamStandings && !awayTeamStandings) {
    return null;
  }

  if (homeTeamStandings && awayTeamStandings) {
    // have nested if statements for readability
    if (homeTeamStandings.ranking < awayTeamStandings.ranking) {
      return [homeTeamStandings, awayTeamStandings];
    }
    return [awayTeamStandings, homeTeamStandings];
  }

  if (homeTeamStandings) {
    return [homeTeamStandings, null];
  }

  if (awayTeamStandings) {
    return [awayTeamStandings, null];
  }
};

export default getMatchupStandings;
